import { render, staticRenderFns } from "./AdvicesCategory.vue?vue&type=template&id=5d8ecaef&"
import script from "./AdvicesCategory.vue?vue&type=script&lang=js&"
export * from "./AdvicesCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports